export default {
  path: '/product',
  component: () => import('../../views/product/product-router.vue'),
  children: [
    {
      path: '',
      name: 'Product',
      component: () => import('../../views/product/pages/Product.vue'),
      meta: {
        name: 'navigationDrawer.product',
        icon: '/icons/box.svg',
        auth: true
      }
    },
    {
      path: 'product-create',
      name: 'ProductCreate',
      component: () => import('../../views/product/pages/ProductCreate.vue'),
      meta: {
        name: 'navigationDrawer.product',
        icon: '/icons/box.svg',
        auth: true
      }
    },
    {
      path: 'product-edit/:id',
      name: 'ProductEdit',
      component: () => import('../../views/product/pages/ProductEdit.vue'),
      meta: {
        name: 'navigationDrawer.product',
        icon: '/icons/box.svg',
        auth: true
      }
    },
    {
      path: 'product-detail/:id',
      name: 'ProductDetail',
      component: () => import('../../views/product/pages/ProductDetail.vue'),
      meta: {
        name: 'navigationDrawer.product',
        icon: '/icons/box.svg',
        auth: true
      }
    },
    {
      path: 'product-unit/:id',
      name: 'ProductUnit',
      component: () => import('../../views/product/pages/ProductUnit.vue'),
      meta: {
        name: 'navigationDrawer.product',
        icon: '/icons/box.svg',
        auth: true
      }
    }
  ]
}
